import { Icon } from '@iconify/react';
import React from 'react';
import MednaBrand from '../../config/MednaBrand';

export default function ContactInfoWidget() {
  const { address, phone, supportEmail } = MednaBrand;
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        {address}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        {phone}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        {supportEmail}
      </li>
    </ul>
  );
}
